import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-346f4662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container px-5 py-4" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex position-fixed w-100 h-100 align-items-center justify-content-center",
  style: {"z-index":"100000","background-color":"rgba(255, 255, 255, 0.75)","left":"0px","top":"0px"}
}
const _hoisted_3 = { class: "d-block text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center my-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 alert-info p-4 rounded-3" }, [
    /*#__PURE__*/_createElementVNode("h6", { class: "text-left fw-bold" }, " Esta actividad es con cupos limitados y requiere que complete sus datos personales para confirmar. "),
    /*#__PURE__*/_createElementVNode("p", null, " Al inscribirse, usted acepta las siguientes condiciones para participar: "),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, " Contar con la licencia/s de conducir vigente/s y ser mayor de edad (18 años). Llevar a un acompañante mayor de 12 años de edad. "),
      /*#__PURE__*/_createElementVNode("li", null, "La participación del invitado es opcional."),
      /*#__PURE__*/_createElementVNode("li", null, " En caso de contar con una restricción alimenticia o de salud, informar al organizador al inicio de la actividad. "),
      /*#__PURE__*/_createElementVNode("li", null, "Asistir con el vehículo de su propiedad y en condiciones adecuadas."),
      /*#__PURE__*/_createElementVNode("li", null, " El tanque de combustible debe estar lleno. "),
      /*#__PURE__*/_createElementVNode("li", null, "Presión y estado de los neumáticos adecuado según el modelo."),
      /*#__PURE__*/_createElementVNode("li", null, "Frenos y amortiguadores en condiciones óptimas."),
      /*#__PURE__*/_createElementVNode("li", null, "Asegúrese de conocer las condiciones de su seguro automotor, el cual deberá estar vigente."),
      /*#__PURE__*/_createElementVNode("li", null, "Es obligatorio firmar el deslinde de responsabilidad."),
      /*#__PURE__*/_createElementVNode("li", null, "Se deben acatar las medidas de seguridad impuestas por el organizador. En caso de no respetarlas, el organizador se reserva el derecho de admisión.")
    ]),
    /*#__PURE__*/_createElementVNode("h6", null, "Una vez completado el formulario, recibirá en su casilla un email de confirmación.")
  ])
], -1))
const _hoisted_6 = { class: "row gy-3 my-3" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "row mt-5" }
const _hoisted_10 = { class: "col-6 col-md-6 d-flex justify-content-start" }
const _hoisted_11 = { class: "col-6 col-md-6 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInfoTitles = _resolveComponent("AppInfoTitles")!
  const _component_PersonalDate = _resolveComponent("PersonalDate")!
  const _component_VersionCard = _resolveComponent("VersionCard")!
  const _component_CompanionDetails = _resolveComponent("CompanionDetails")!
  const _component_Documentation = _resolveComponent("Documentation")!
  const _component_TermsAndConditions = _resolveComponent("TermsAndConditions")!
  const _component_AppButtonReturn = _resolveComponent("AppButtonReturn")!
  const _component_AppButtonContinue = _resolveComponent("AppButtonContinue")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h6", null, _toDisplayString(_ctx.loading.text), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(() => [
        _createVNode(_component_AppInfoTitles, {
          vehiculoVisible: false,
          activities: "Academy"
        }),
        _hoisted_5,
        _createVNode(_component_PersonalDate, {
          modelValue: _ctx.form.personal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.personal) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_VersionCard, {
          modelValue: _ctx.form.version,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.version) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.t('formDatos.titles.subtitle3')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CompanionDetails, {
              modelValue: _ctx.form.acompanianteUno,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.acompanianteUno) = $event)),
              "label-name": "formularios.nombreAcom1.label"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_Documentation, {
          modelValue: _ctx.form.documentacion,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.documentacion) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_TermsAndConditions, {
          modelValue: _ctx.form.terminos,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.terminos) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_AppButtonReturn)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.form.vip.isClient !== null)
              ? (_openBlock(), _createBlock(_component_AppButtonContinue, {
                  key: 0,
                  disabled: _ctx.loading.status
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}